const text = `[[topSection]][[publisherName]] We think your online privacy is important. We therefore want to inform you of the following:

We store some information on your device to make this website function. Your device can also be accessed by [[thirdPartiesUrl]] for similar information storage.

Personal data like your ip address and unique user ids can be used by us and [[thirdPartiesUrl]] for the following purposes for which [[thirdPartiesUrl]] can request your consent:
[[purposes]]

Purposes for which [[thirdPartiesUrl]] claim legitimate interest without the right to object:
[[legitimateInterest]]

And features for which [[thirdPartiesUrl]] explicitly require your opt-in:
[[features]]

Nous et nos [[partnersScreen]] [[totalVendors]] stockons et/ou accédons aux informations sur votre appareil pour des publicités et du contenu personnalisés.

We provide this interface to give you control of your privacy settings. You can change your privacy settings at any time while visiting our website. To open this dialog, navigate to the Privacy button on your screen. 

Besides asking for your consent [[thirdPartiesUrl]] can claim [[legitimateInterestUrl]] as a legal basis for processing personal data. In most cases you have a right to object to this. A signal to relay your objection to a 'third party' is managed by this privacy manager.

Whithholding consent can lead to more ads and ads not suited to your interests.

Any consent, objection and opt-in you give is limited in scope to this website.
[[bottomSection]]
`;
export default text;